const reactDomRoot = document.getElementById("repareo-app");
export { reactDomRoot };
